import { RefObject, useEffect } from "react"

export function useOutsideClick(ref: RefObject<HTMLElement | null>, callback: () => void, isModal: boolean = false) {
  useEffect(() => {
    let touchStartX = 0
    let touchStartY = 0
    let touchMoved = false

    function handleTouchStart(event: TouchEvent) {
      touchStartX = event.touches[0].clientX
      touchStartY = event.touches[0].clientY
      touchMoved = false
    }

    function handleTouchMove(event: TouchEvent) {
      const touchEndX = event.touches[0].clientX
      const touchEndY = event.touches[0].clientY
      const deltaX = Math.abs(touchEndX - touchStartX)
      const deltaY = Math.abs(touchEndY - touchStartY)

      if (deltaX > 10 || deltaY > 10) {
        touchMoved = true
      }
    }

    function handleTouchEnd(event: TouchEvent) {
      if (!touchMoved) {
        const modal = isModal ? document.querySelector(".static-select__menu-portal") : null

        if (
          ref.current &&
          !ref.current.contains(event.target as HTMLElement) &&
          (!modal || !modal.contains(event.target as HTMLElement))
        ) {
          callback()
          event.stopPropagation()
        }
      }
    }

    function handleClickOutside(event: MouseEvent) {
      const modal = isModal ? document.querySelector(".static-select__menu-portal") : null

      if (
        ref.current &&
        !ref.current.contains(event.target as HTMLElement) &&
        (!modal || !modal.contains(event.target as HTMLElement))
      ) {
        callback()
        event.stopPropagation()
      }
    }

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") {
        callback()
        event.stopPropagation()
      }
    }

    document.addEventListener("click", handleClickOutside, true)
    document.addEventListener("keydown", handleKeyDown, true)
    document.addEventListener("touchstart", handleTouchStart, true)
    document.addEventListener("touchmove", handleTouchMove, true)
    document.addEventListener("touchend", handleTouchEnd, true)

    return () => {
      document.removeEventListener("click", handleClickOutside, true)
      document.removeEventListener("keydown", handleKeyDown, true)
      document.removeEventListener("touchstart", handleTouchStart, true)
      document.removeEventListener("touchmove", handleTouchMove, true)
      document.removeEventListener("touchend", handleTouchEnd, true)
    }
  }, [ref])
}
